var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_1099)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.5C4.47803 20.5 0 16.022 0 10.5C0 4.97803 4.47803 0.5 10 0.5C15.522 0.5 20 4.97803 20 10.5C20 16.022 15.522 20.5 10 20.5ZM8.62417 12.2595L14.6251 6.25866C14.8328 6.05094 15.1737 6.05307 15.3793 6.25866L16.0598 6.93913C16.2654 7.14472 16.2654 7.4878 16.0598 7.69331L9.01181 14.7413C8.88575 14.8674 8.70866 14.917 8.54276 14.8885C8.42921 14.8743 8.31968 14.8244 8.23417 14.739L3.94087 10.4457C3.73567 10.2405 3.73323 9.89913 3.94087 9.69142L4.62134 9.01095C4.82906 8.80331 5.16787 8.80331 5.37559 9.01095L8.62417 12.2595Z",
    fill: "#009F0C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_1099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/green-check.dc45c363f1b6e7f2288947b6945d009e.svg";
export { ForwardRef as ReactComponent };